import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField
} from "@mui/material";

const DateRangeModal = ({
  open,
  onClose,
  onConfirm,
  fromDate,
  toDate,
  setFromDate,
  setToDate
}) => {
  const handleConfirm = () => {
    if (!fromDate) {
      alert("Date is required.");
      return;
    }
    // if (new Date(fromDate) > new Date(toDate)) {
    //   alert("From date cannot be later than To date.");
    //   return;
    // }
    onConfirm({ fromDate });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        Select Breaklist's Generation Date for Update Records
      </DialogTitle>
      <DialogContent dividers>
        <TextField
          margin="dense"
          label="Date"
          type="date"
          fullWidth
          InputLabelProps={{ shrink: true }}
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
        />
{/*        <TextField
          margin="dense"
          label="To"
          type="date"
          fullWidth
          InputLabelProps={{ shrink: true }}
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
        />*/}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleConfirm} variant="contained" color="primary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DateRangeModal;